module.exports = "/static/assets/af627820e3114b93ef21d4a7de42e80b.gif";